import * as Yup from "yup";

export const BulkTicketsFormSchema = Yup.object().shape({
  from: Yup.number()
    .min(1, "Ticket number must be greater than 0")
    .typeError("From number must be a number")
    .required("Please enter a from ticket number"),
});
